import { IDictionary, createMutableAction } from '@bimser/core';
import { RESOLVE_CONFIRMATION_MODAL } from './actionTypes';
import { Map } from 'immutable';

export const onConfirmationResolveAction = (data?: IDictionary<string>) =>
	createMutableAction(RESOLVE_CONFIRMATION_MODAL, data ? Map(data) : null);
